const limitType = {
  DAILY: 'DAILY',
  TRANSACTION: 'TRANSACTION'
};

module.exports = limitType;
